import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import _ from "lodash";
import { setbadgeJson, setSelectedElement } from "BadgeDesignAction";
import { badgeDefaultStructure } from "BadgeDesignReducer"; // Array of objects
import { DEFAULTFONTSIZE, DEFAULTFONTFAMILY } from "../badge-constants";

const BadgeElementDelete = (props) => {
  const { templateJson, classAsProp, laveldata } = props;

  /* Remove badge element function */
  const removeElemnet = (laveldata) => {
    // console.log("laveldata", laveldata);
    // console.log("templateJson", templateJson);
    // console.log("badgeDefaultStructure", badgeDefaultStructure);

    var findMatchIndex = _.findIndex(templateJson, (obj) => {
      return obj.name === laveldata.name;
    });
    // console.log("findMatchIndex :- ", findMatchIndex);

    if (laveldata.htmlType === "input") {
      var findDefaultData = [
        {
          ...templateJson[findMatchIndex],
          hidden: true,
          displayOrder: laveldata.displayOrder,
          label: true,
          textValue: "",
          scale: 1,
          x: 130,
          y: 183,
          style: {
            width: "max-content",
            height: "max-content",
            textAlign: "center",
            textDecoration: "",
            fontWeight: "normal",
            fontSize: DEFAULTFONTSIZE,
            fontFamily: DEFAULTFONTFAMILY,
            fontStyle: "",
            position: "absolute",
          },
        },
      ];
    } else {
      var findDefaultData = _.filter(badgeDefaultStructure, (obj) => {
        return obj.name === laveldata.name;
      });
    }
    // console.log("findDefaultData :- ", findDefaultData);

    if (findDefaultData.length > 0) {
      findDefaultData[0].hidden = true;
      findDefaultData[0].displayOrder = laveldata.displayOrder;

      templateJson[findMatchIndex] = findDefaultData[0];
    }
    // console.log("final templateJson :- ", templateJson);

    props.setSelectedElement(); // Clear selected badge element for style changes
    props.setbadgeJson(templateJson); // Update to store

    let elements = document.getElementById(
      `badge_elements[${laveldata.displayOrder}]`
    );
    elements.click();
    // console.log("elements :- ", elements);
  };

  return (
    <div className="badge-element-button-container">
      <i
        className={classAsProp}
        style={props.styleAsProp}
        onClick={(e) => removeElemnet(laveldata)}
      ></i>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    session: state.session,
    templateJson: state.templateJson,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setbadgeJson,
      setSelectedElement,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(BadgeElementDelete);
